// extracted by mini-css-extract-plugin
module.exports = {"wrap":"SiteFooter_wrap__3fZXK"};